(function ($) {
	var personSearchGrid = (function () {
		var $grid, group, $reset_button, peopleShuffleInstance, board_commission;
		var $board_commission_select, $active_position_select, position;
		var init = function () {

			$board_commission_select = jQuery('#board-commission-select');
			position_select_display();

			$grid = jQuery('#person-listing-container');
			$reset_button = jQuery('#filter-controls-clear-all');

			board_commission = 'all-boards-commissions';
			$board_commission_select.val('all-boards-commissions');

			position = 'all-positions';
			jQuery('.position-select').val('all-positions');

			$reset_button.click(function (e) {
				e.preventDefault();
				$board_commission_select.val('all-boards-commissions');
				board_commission = 'all-boards-commissions';

				position = 'all-positions';
				jQuery('.position-select').val('all-positions');

				$board_commission_select.trigger('change');

				renderListingQueryDisplay();
				peopleShuffleInstance.filter(Shuffle.ALL_ITEMS);
			});

			registerBoardCommissionSelectEventListener();

			var Shuffle = window.Shuffle;
			var element = document.querySelector('#person-listing-container');
			if (element) {
				var sizer = element.querySelector('#person-listing-container');

				peopleShuffleInstance = new Shuffle(element, {
					speed: 750,
					easing: 'cubic-bezier(0.230, 1.000, 0.320, 1.000)',
					itemSelector: '.person-card__item-container',
					sizer: sizer,
					isCentered: true
				});

				peopleShuffleInstance.on(Shuffle.EventType.LAYOUT, function () {
					$(window).trigger('scroll');
					$(window).trigger('resize');
					console.log('Things finished moving!');
				});

				$('.filter-controls__display-label-container').removeClass('hide');
				renderListingQueryDisplay();
			}

		};

		var renderListingQueryDisplay = function () {

			var display_text = '';

			if (board_commission === 'all-boards-commissions') {
				display_text = candidate_query_display_text.all;
			} else {
				if (position === 'all-positions') {
					var board_commission_label = $board_commission_select.find("option[value='" + board_commission + "']").text().trim();
					display_text = candidate_query_display_text['all-boards-commissions'].replace("%BOARD_COMMISSION%", board_commission_label);
				} else {
					var board_commission_label = $board_commission_select.find("option[value='" + board_commission + "']").text().trim();
					var position_label = $active_position_select.find("option[value='" + position + "']").text().trim();

					display_text = candidate_query_display_text['board-commission-and-position'].replace("%BOARD_COMMISSION%", board_commission_label);
					display_text = display_text.replace("%POSITION%", position_label);
				}

			}

			$('#filter-controls__display-label').html(display_text);

		}

		var processFilter = function () {
			renderListingQueryDisplay();
			peopleShuffleInstance.filter(function (element, shuffle) {

				if (board_commission !== 'all-boards-commissions') {
					var element_board_commission = JSON.parse(element.dataset.groups);
					if (!element_board_commission.includes(board_commission)) {
						return false;
					} else {
						if (position !== 'all-positions') {
							var element_position = JSON.parse(element.dataset.groups);
							if (!element_position.includes(position)) {
								return false;
							}
						}
					}
				}
				return true;
			});
		}


		var registerBoardCommissionSelectEventListener = function () {
			$board_commission_select.on('change', function (e) {
				e.preventDefault();

				board_commission = $board_commission_select.val();
				processFilter();
			});
		};
		var registerPositionSelectEventListener = function () {
			$active_position_select.on('change', function (e) {
				e.preventDefault();

				position = $active_position_select.val();
				processFilter();
			});
		};
		var position_select_display = function () {
			$board_commission_select.on('change', function (e) {
				let board_commission_selected_type = $board_commission_select.val();
				console.log(board_commission_selected_type);
				jQuery('.position-select-filter-section').addClass('hide');
				jQuery('.position-select-filter-section.' + board_commission_selected_type).removeClass('hide');
				$active_position_select = jQuery('.position-select-filter-section.' + board_commission_selected_type + ' select');
				$active_position_select.off();
				position = 'all-positions';
				registerPositionSelectEventListener();
			});
		};
		return {
			init: init
		};

	})();
	personSearchGrid.init();

	$('a.person-card__open-modal-link').on('click', function (e) {
		e.preventDefault();
		let $this = $(this);
		let post_id = $this.data('post-id');

		let $iframe_video = $('#bio-modal-' + post_id).find('iframe.lpc-candidate-video');

		if (!$iframe_video.hasClass('candidate-video-loaded')) {
			$iframe_video.attr('src', $iframe_video.data('candidate-video-src'));
			$iframe_video.addClass('candidate-video-loaded');
		}

		$('#bio-modal-' + post_id).foundation('open');

	});

	$('.liberal-modal-close').on('click', function (e) {
		let $modal_ele = $(this).closest('.reveal');
		$modal_ele.foundation('close');
	});

}(jQuery))
